import React, { useEffect, useState } from 'react'

import { Preloader } from '../../../components/Preloader/Preloader'
import { SocialLinks } from '../../../components/SocialLinks/SocialLinks'
import { HistoryTable } from '../HistoryTable/HistoryTable'
import { OwnerFormAdd } from '../OwnerFormAdd/OwnerFormAdd'
import { OwnerFormChange } from '../OwnerFormChange/OwnerFormChange'
import { CustomerForm } from '../CustomerForm/CustomerForm'

import { ReactComponent as Arrow } from '../../../assets/icons/back-arrow.svg'

import CoolCats from '../../../api/contract'
import Backend from '../../../api/backend'
import { BACKEND_IP, BACKEND_PORT, BACKEND_URL } from '../../../utils/const'
import { numSpaces, telegramLink, twitterLink } from '../../../utils/functions'

import './MarketTokenView.scss'

export const MarketTokenView = ({
  id,
  onBack
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [contract, setContract] = useState()
  const [myAddress, setMyAddress] = useState(window.tronWeb && window.tronWeb.defaultAddress ? window.tronWeb.defaultAddress.base58 : '')
  const [info, setInfo] = useState(null)
  const [amount, setAmount] = useState('')
  const [bidAmount, setBidAmount] = useState('')
  const [actionResult, setActionResult] = useState('')

  useEffect(() => {
    let isMount = true

    new CoolCats().init(window.tronWeb)
    .then(c => {
      if (isMount) setContract(c)
    })
    .catch(console.log)

    return () => isMount = false
  }, [setContract])

  useEffect(() => {
    if (myAddress) return

    const interval = setInterval(() => {
      if (window.tronWeb && window.tronWeb.defaultAddress) {
        clearInterval(interval)
        setMyAddress(window.tronWeb.defaultAddress.base58)
      }
    }, 500);

    return () => clearInterval(interval)
  }, [myAddress, setMyAddress])

  useEffect(() => {
    let isMount = true

    new Backend(BACKEND_URL, BACKEND_PORT).getTokenInfo(id)
      .then(info => {
        if (isMount) setInfo(info)
      })
      .catch(console.log)

    return () => isMount = false
  }, [id, setInfo])

  const contractAction = (action, successLabel = 'SUCCESS', onEnd) => {
    const b = new Backend(BACKEND_URL, BACKEND_PORT)
    
    setIsLoading(true)
    setActionResult('')
  
    action(b)
      .then(() => setActionResult(successLabel))
      .then(() => b.getTokenInfo(id))
      .then(res => setInfo(v => ({
        ...v,
        ...res,
      })))
      .catch(e => {
        console.log(e)
        setActionResult('ERROR')
      })
      .finally(() => {
        if (onEnd) onEnd()
        setIsLoading(false)
      })
  }

  const onOffer = () => {
    contractAction(
      async (b) => {
        await contract.putOnMarket(id, amount * 1000000)
        return b.waitTokenOnSale(id)
      },
      'OFFER MADE',
      () => setAmount('')
    )
  }

  const onSavePrice = () => {
    contractAction(
      async (b) => {
        await contract.changeLotPrice(id, amount * 1000000)
        return b.waitTokenPriceChanged(id)
      },
      'PRICE CHANGED',
      () => setAmount('')
    )
  }

  const onAcceptBid = (bidID) => {
    contractAction(
      async (b) => {
        await contract.acceptBid(id, bidID)
        return b.waitBidAccept(id, bidID)
      }
    )
  }

  const onCancel = () => {
    contractAction(
      async (b) => {
        await contract.withdrawFromMarket(id)
        return b.waitTokenWithdraw(id)
      }
    )
  }

  const onCancelBid = (bidID) => {
    contractAction(
      async (b) => {
        await contract.cancelBid(bidID)
        return b.waitUnbid(id, bidID)
      }
    )
  }

  const onBuy = () => {
    contractAction(
      async (b) => {
        await contract.buyFromMarket(id)
        return b.waitMarketTrade(id)
      },
      'PURCHASED'
    )
  }

  const onBid = () => {
    contractAction(
      async (b) => {
        const bid = await contract.addBid(id, bidAmount * 1000000)
        return b.waitBid(id, bid.id)
      },
      'BID PLACED',
      () => setBidAmount('')
    )
  }

  const infoLink = (link, label) => (
    <a
      href={ link }
      className="info-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      { label }
    </a>
  )

  // console.log(info)
  const tokenOwner = info ? info.marketItem.owner ? info.marketItem.owner : info.owner : '-'
  const isOwner = tokenOwner === myAddress

  const attrs = []
  if (info && info.imageInfo.traits)
    for (const key in info.imageInfo.traits) {
      if (key !== 'tier')
        attrs.push(
          <div key={ key } className="prop-item">
            <span className="title">
              { key }
            </span>
            <span className="subtitle">
              { info.imageInfo.traits[key] }
            </span>
          </div>
        )
    }

  let maxBid = false
  let myBid = false
  let history = []
  if (info && info.imageInfo.lotPrice > 0 && info.history) {
    if (info.history) {
      history = info.history
      .filter((item, i, list) => {
        const ok = list[i + 1]
          && (
            item.event !== list[i + 1].event
            || item.txid !== list[i + 1].txid
          )
        
          return ok
      })

      const actualBids = history.filter(v => parseInt(v.price) === info.imageInfo.maxBid && v.event === 'BID PLACED')
        .sort((a, b) => a.timestamp > b.timestamp);
      if (actualBids.length) maxBid = actualBids[0];
    }

    if (info.bids) {
      info.bids.forEach(item => {
        if (item.payer === myAddress) myBid = item
      })
    }
  }

  // if (myBid) console.log(myBid)

  return (
    <div className="market-token-view">
      <button
        className="back-button"
        onClick={ onBack }
      >
        <Arrow />
      </button>
      <div className="view-container">
        {
          info
          ? (
            <>
              <div className="main-row">
                <div className="image-container">
                  <img
                    src={`${ BACKEND_IP }/img/${ id }.jpg`}
                    alt="cat"
                  />
                  <p className="share">
                    No harm in bragging: let the friends see your brand new Cool Cat.
                  </p>
                  <div className="links-row">
                    <SocialLinks
                      className="icon-link"
                      twlink={twitterLink( id )}
                      tgLink={telegramLink( id )}
                    />
                  </div>
                </div>
                <div>
                  <div className="info-container">
                    <div className="stat-container">
                      <h1>
                        TRON COOLCAT #{ id }
                      </h1>
                      <div className="stat-row">
                        <div className="stat-row-item">
                          <span className="stat-label">
                            RARITY RANK 
                          </span>
                          <span className="stat-value">
                            {
                              infoLink(
                                `https://rarity.tools/cool-cats-nft/view/${ id }`,
                                `#${ info.imageInfo.rank }`
                              )
                            }
                          </span>
                        </div>
                        <div className="stat-row-item">
                          <span className="stat-label">
                            TIER
                          </span>
                          <span className="stat-value">
                            { info.imageInfo.traits.tier }
                          </span>
                        </div>
                        <div className="stat-row-item">
                          <span className="stat-label">
                            OWNED BY
                          </span>
                          <span className="stat-value">
                            {
                              infoLink(
                                `https://tronscan.io/#/address/${ tokenOwner }`,
                                tokenOwner.substr(0, 7)
                              )
                            }
                          </span>
                        </div>
                      </div>
                      {
                        (info.imageInfo.lotPrice > 0 || maxBid)
                        && (
                          <div>
                            {
                              info.imageInfo.lotPrice > 0
                              && (
                                <div className="stat-line">
                                  <span className="stat-label">
                                    PRICE
                                  </span>
                                  <span className="stat-value">
                                    { numSpaces(info.imageInfo.lotPrice / 1000000) } TRX
                                  </span>
                                </div>
                              )
                            }
                            {
                              maxBid
                              && (
                                <div className="stat-subline">
                                  <div>
                                    <span>
                                      BID
                                    </span>
                                    <span>
                                      { numSpaces(maxBid.price / 1000000) } TRX
                                    </span>
                                  </div>
                                  <div>
                                    <span>
                                      FROM
                                    </span>
                                    <span>
                                      {
                                        maxBid.payer
                                        ? infoLink(
                                            `https://tronscan.io/#/address/${ maxBid.payer }`,
                                            maxBid.payer.substr(0, 7)
                                          )
                                        : '-'
                                      }
                                    </span>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        )
                      }
                    </div>
                    {
                      isOwner
                      ? info.imageInfo.lotPrice > 0
                        ? (
                          <OwnerFormChange
                            lock={ isLoading }
                            actionResult={ !isLoading && actionResult }
                            amount={ amount }
                            onChange={ setAmount }
                            onSave={ onSavePrice }
                            onAccept={ maxBid ? () => onAcceptBid(maxBid.id) : false }
                            onCancel={ onCancel }
                          />
                        )
                        : (
                          <OwnerFormAdd
                            lock={ isLoading }
                            actionResult={ !isLoading && actionResult }
                            amount={ amount }
                            onChange={ setAmount }
                            onOffer={ onOffer }
                          />
                        )
                      : info.imageInfo.lotPrice > 0
                        ? (
                            <CustomerForm
                              lock={ isLoading }
                              actionResult={ !isLoading && actionResult }
                              maxBid={ info.imageInfo.lotPrice / 1000000 }
                              minBid={ maxBid ? maxBid.price : 0 }
                              bid={ bidAmount }
                              onChange={ setBidAmount }
                              onBid={ myBid ? false : onBid }
                              onBuy={ onBuy }
                              onCancel={ myBid ? () => onCancelBid(myBid.id) : false }
                            />
                          )
                          : (
                            <div className="action-label">
                              <span>
                                NOT FOR SALE
                              </span>
                            </div>
                          )
                    }
                  </div>
                </div>
              </div>
              <div className="props-container">
                <h2>
                  PROPERTIES
                </h2>
                <div className="prop-list">
                  { attrs }
                </div>
              </div>
              {
                history.length > 0
                && (
                  <div className="table-container">
                    <h2>
                      MARKET HISTORY
                    </h2>
                    <HistoryTable list={ history.slice(0, 10) } />
                  </div>
                )
              }
            </>
          )
          : <Preloader />
        }
      </div>
    </div>
  )
}